import { render, staticRenderFns } from "./LiveratesLogs.vue?vue&type=template&id=f9c927fc&scoped=true"
import script from "./LiveratesLogs.vue?vue&type=script&lang=js"
export * from "./LiveratesLogs.vue?vue&type=script&lang=js"
import style0 from "./LiveratesLogs.vue?vue&type=style&index=0&id=f9c927fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c927fc",
  null
  
)

export default component.exports